<template>
    <v-container fluid>
        <v-row v-show="populating == false && populatingFailure == false">
            <v-col cols="12" md="6">
                <v-card>
                    <v-form ref="billingForm" v-model="isValid">
                        <v-card-text>
                            <v-container class="pb-0" fluid>
                                <v-row v-if="billing.id > 0" class="pb-0">
                                    <v-col
                                        cols="12"
                                        class="my-0 py-0 text-subtitle-1 font-weight-black"
                                        >Patient Details</v-col
                                    >
                                    <v-col cols="12" class="my-0 py-0"
                                        >Incident #{{
                                            billing.patient.incidentId
                                        }}</v-col
                                    >
                                    <v-col cols="12" class="my-0 py-0"
                                        >{{ billing.patient.identity.name }}
                                        {{
                                            billing.patient.identity.surname
                                        }}</v-col
                                    >
                                    <v-col cols="12" class="my-0 py-0">{{
                                        billing.patient.identity
                                            .identificationNumber
                                    }}</v-col>
                                    <v-col cols="12"></v-col>
                                    <v-col
                                        cols="12"
                                        class="my-0 py-0 text-subtitle-1 font-weight-black"
                                        >Provider Details</v-col
                                    >
                                    <v-col cols="12" class="my-0 py-0">{{
                                        getProviderName(billing.providerId)
                                    }}</v-col>
                                    <v-col cols="12" class="my-0 py-0">{{
                                        getProviderDisciplineName(
                                            billing.discipline
                                        )
                                    }}</v-col>
                                    <v-col cols="12"></v-col>
                            <!--<v-col cols="12">
                                <v-btn
                                    :disabled="isLoading || !hasFinalInvoice || alreadyInAccount"
                                    :loading="convertingToAccount"
                                    @click="convertToAccount"
                                    color="secondary"
                                    >Convert to Account</v-btn
                                >
                            </v-col>-->
                            <v-col cols="12">
                                <v-btn
                                    :disabled="isLoading /*|| !alreadyInAccount*/"
                                    v-show="/*alreadyInAccount && */billing.invoiceFileId > 0"
                                    @click="
                                        getFile(
                                            billing.invoiceFileId,
                                            'Billing' + billing.id + '_'
                                        )
                                    "
                                    color="secondary"
                                    >Download Current Combined Invoice</v-btn
                                >
                            </v-col>
                            <v-col cols="12">
                                <v-btn
                                    :disabled="isLoading || hasFinalInvoice/* || alreadyInAccount*/"
                                    :loading="finalInvoiceLoadedAction"
                                    @click="finalInvoiceLoaded"
                                    color="secondary"
                                    >Final invoice and clinical notes loaded{{hasFinalInvoice ? ": Yes" : ""}}</v-btn
                                >
                            </v-col>
                            <v-col cols="12">
                                <v-btn
                                    :disabled="isLoading"
                                    @click="devgetclinicalnotes"
                                    color="secondary"
                                    >test-dev-get-clinical-notes</v-btn
                                >
                            </v-col>
                                </v-row>
                                <v-row v-else class="pb-0">
                                    <v-col cols="12" justify="start">
                                        <v-btn
                                            @click="loadPatientFindForm"
                                            class="text-none"
                                            color="light-blue darken-1"
                                            dark
                                            v-if="!billing.patient"
                                        >
                                            <v-icon dark left
                                                >mdi-billing</v-icon
                                            >Specify Patient
                                        </v-btn>
                                        <v-btn
                                            @click="
                                                billing.patient = null;
                                                billing.patientId = 0;
                                            "
                                            class="text-none"
                                            color="light-blue darken-1"
                                            text
                                            v-else
                                        >
                                            <v-icon dark left>mdi-close</v-icon
                                            >Clear Patient
                                        </v-btn>
                                        <v-card v-if="billing.patient">
                                            <v-card-text>
                                                Incident #{{
                                                    billing.patient.incidentId
                                                }}
                                                <br />
                                                {{
                                                    billing.patient.identity
                                                        .name
                                                }}
                                                {{
                                                    billing.patient.identity
                                                        .surname
                                                }}
                                                <br />
                                                <span v-if="identityTypes">
                                                    {{
                                                        identityTypes.find(
                                                            (x) =>
                                                                x.key ==
                                                                billing.patient
                                                                    .identity
                                                                    .identityTypeId
                                                        )
                                                            ? identityTypes.find(
                                                                  (x) =>
                                                                      x.key ==
                                                                      billing
                                                                          .patient
                                                                          .identity
                                                                          .identityTypeId
                                                              ).value
                                                            : ""
                                                    }}
                                                </span>
                                                :
                                                {{
                                                    billing.patient.identity
                                                        .identificationNumber
                                                }}
                                            </v-card-text>
                                        </v-card>
                                        <br />
                                        <div
                                            style="color: red"
                                            v-show="!billing.patient"
                                        >
                                            Patient identity is required
                                        </div>
                                    </v-col>

                                    <v-col cols="12">
                                        <v-select
                                            :disabled="
                                                isLoading || billing.id > 0
                                            "
                                            :items="activeProviders"
                                            :rules="[requiredRule]"
                                            @change="
                                                populateProviderDisciplines
                                            "
                                            clearable
                                            item-text="value"
                                            item-value="key"
                                            label="Provider"
                                            v-model="billing.providerId"
                                        ></v-select>
                                    </v-col>

                                    <v-col cols="12">
                                        <v-select
                                            :disabled="
                                                isLoading || billing.id > 0
                                            "
                                            :items="providerDisciplines"
                                            :rules="[
                                                (v) =>
                                                    !!v ||
                                                    v === 0 ||
                                                    'required',
                                            ]"
                                            clearable
                                            item-text="value"
                                            item-value="key"
                                            label="Discipline"
                                            v-model="billing.discipline"
                                        ></v-select>
                                    </v-col>
                                </v-row>
                                <v-row
                                    align="end"
                                    class="pt-0"
                                    justify="space-between"
                                    no-gutters
                                >
                                    <v-btn
                                        :disabled="isLoading && !isDeleting"
                                        :loading="isDeleting"
                                        @click="deleteEntity"
                                        class="text-none"
                                        color="warning darken-1"
                                        text
                                        v-show="billing.id > 0"
                                        >Delete</v-btn
                                    >
                                    <v-spacer></v-spacer>
                                    <v-btn
                                        v-if="!(billing.id > 0)"
                                        :disabled="isLoading && !isSaving"
                                        :loading="isSaving"
                                        @click="saveEntity"
                                        class="text-none"
                                        color="secondary darken-1"
                                        text
                                        >{{
                                            billing.id > 0 ? "Update" : "Add"
                                        }}</v-btn
                                    >
                                </v-row>
                            </v-container>
                        </v-card-text>
                    </v-form>
                    <v-snackbar
                        :color="notifyColor"
                        :timeout="15000"
                        top
                        v-model="notifyShow"
                    >
                        {{ notifyMessage }}
                        <template v-slot:action="{ attrs }">
                            <v-btn
                                @click="notifyShow = false"
                                class="text-none"
                                icon
                                v-bind="attrs"
                            >
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </template>
                    </v-snackbar>
                </v-card>
            </v-col>
            <v-col cols="12" md="6" no-gutters>
                <h3>
                    Invoices
                    <v-btn
                        :disabled="isLoading || !(billing.id > 0) || hasFinalInvoice /*|| alreadyInAccount*/"
                        @click="newBillingItemForm"
                        class="text-none ml-2"
                        color="secondary darken-1"
                        fab
                        x-small
                    >
                        <v-icon>mdi-plus</v-icon>
                    </v-btn>
                </h3>
                <v-row
                    :key="billingItem.id"
                    v-for="(billingItem, index) in billing.billingItems"
                >
                    <v-col cols="12">
                        <BillingItemForm
                            :billing-item-in="billingItem"
                            :key="index"
                            :is-modal="false"
                            :has-final-invoice="hasFinalInvoice"
                            :first-report-saved="index != 0/*firstReportAlreadySaved*/"
                            :anesthesia="billing.discipline == 2 || billing.discipline == 40"
                            @loadBilling="loadBilling"
                            @notify="notify"
                            @reload="loadBilling"
                        />
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <v-row v-show="populating == true">
            <v-col class="text-center" cols="12">
                <v-progress-circular
                    :size="50"
                    color="secondary"
                    indeterminate
                ></v-progress-circular>
            </v-col>
        </v-row>
        <v-row v-show="populating == false && populatingFailure == true">
            <v-col class="text-center" cols="12"
                >Could not load the form. Please refresh the page and try again.
                If the issue persists contact support.</v-col
            >
        </v-row>
        <v-dialog persistent v-model="patientFindFormVisible" width="500px">
            <PatientFindForm
                :key="patientFindFormKey"
                @close="closePatientFindForm"
                @located="locatedPatient"
            />
        </v-dialog>

        <v-dialog persistent v-model="newBillingItemFormShow" width="500px">
            <BillingItemForm
                :billing-item-in="newBillingItem"
                :key="newBillingItemFormKey"
                :is-modal="true"
                @close="closeNewBillingItemForm"
                @loadBilling="loadBilling"
                @notify="notify"
                @reload="loadBilling"
            />
        </v-dialog>
    </v-container>
</template>

<script>
import Billing from "../../models/Billing.model";
import BillingItem from "../../models/BillingItem.model";
import uuid4 from "../../helpers/uuid4";
import PatientFindForm from "../forms/PatientFindForm";
import BillingItemForm from "../forms/BillingItemForm";
export default {
    props: {
        billingId: {
            type: Number,
            default: 0,
        },
    },
    components: {
        PatientFindForm,
        BillingItemForm,
        //
    },
    created: async function () {
        //
    },
    mounted: async function () {
        this.medediStatuses = await this.$store.dispatch(
            "billingitems/getMedediStatuses"
        );
        //this.providers = await this.$store.dispatch("providers/getlist");
        this.providers = await this.$store.dispatch("providers/getlist");
        this.identityTypes = await this.$store.dispatch("identities/getTypes");
        await this.loadBilling();
    },
    data() {
        return {
            medediStatuses: [],
            billingIdValue: this.billingId,
            billingMedediStatuses: [],
            billingLocalStatuses: [],
            populating: true,
            populatingFailure: true,
            requestId: uuid4(),
            providers: [],
            activeProviders: [],
            identityTypes: [],
            providerDisciplines: [],
            billing: {},
            billingIn: {},
            isValid: null,
            isLoading: null,
            isSaving: null,
            isDeleting: null,
            notifyShow: null,
            notifyMessage: null,
            notifyColor: null,
            requiredRule: (v) => !!v || "required",
            lengthRule: (limit) => (v) =>
                !v || v.length <= limit || "exceeds " + limit + " characters",
            emailRule: (v) => /.+@.+$/.test(v) || "invalid email",

            patientFindFormVisible: false,
            patientFindFormKey: 0,

            newBillingItem: {},
            newBillingItemFormShow: false,
            newBillingItemFormKey: null,

            convertingToAccount: false,
            finalInvoiceLoadedAction: false,
        };
    },
    computed: {
        firstReportAlreadySaved() {
            if(this.billing && typeof this.billing.billingItems !== 'undefined')
                return this.billing.billingItems.some(x => x.iaIsSaved || x.arIsSaved);
            else
                return false;
        },
        hasFinalInvoice() {
            return this.billing.convertToAccount == true;
        },
        alreadyInAccount() {
            return this.billing.accountId > 0;
        }
        //
    },
    methods: {
        async devgetclinicalnotes() {
            var f = await this.$store.dispatch(
                        "billings/devgetclinicalnotes",
                        this.billing.id
                    );
            this.getFile(f,'clinicalnotes-test')
        },
        async finalInvoiceLoaded() {
            var isConfirmed = confirm(
                "Are you sure this is your final invoice all other invoices will be administrated?"
            );
            if (isConfirmed) {
                this.isLoading = true;
                this.finalInvoiceLoadedAction = true;
                try {
                    await this.$store.dispatch(
                        "billings/setConvertToAccount",
                        this.billing.id
                    );
                    await this.loadBilling();
                } catch (e) {
                    this.notify(e.response.data, "error");
                } finally {
                    this.isLoading = false;
                    this.finalInvoiceLoadedAction = false;
                }
            }       
        },
        getFile(fileId, namePrefix) {
            this.$store.dispatch("files/get", {
                fileId: fileId,
                namePrefix: namePrefix,
            });
        },
        /*async convertToAccount() {
            this.isLoading = true;
            this.convertingToAccount = true;
            try {
                await this.$store.dispatch(
                    "billings/convertToAccount",
                    this.billing.id
                );
                await this.loadBilling();
            } catch (e) {
                this.notify(e.response.data, "error");
            } finally {
                this.isLoading = false;
                this.convertingToAccount = false;
            }
        },*/
        newBillingItemForm() {
            this.newBillingItemFormKey = null;
            this.newBillingItem = new BillingItem();
            this.newBillingItem.id = 0;
            this.newBillingItem.billingId = this.billing.id;
            this.newBillingItemFormKey = this.newBillingItem.id;
            //test if allowed
            if(!this.billing.billingItems || this.billing.billingItems.length == 0) {
                this.newBillingItemFormShow = true;
                return;
            }

            /* removed by request from christa moller 2024-09-11
            let allSubmitted = true;
            let allCompleted = true;
            for (let index = 0; index < this.billing.billingItems.length; index++) {
                if(index == 0) {
                    if(!this.billing.billingItems[index].iaIsSaved && !this.billing.billingItems[index].arIsSaved)
                        allCompleted = false;
                }
                else if(!this.billing.billingItems[index].prIsSaved)
                    allCompleted = false;
                
                let status = this.billing.billingItems[index].medediStatus;
                let statuses = this.medediStatuses.filter(function(item) { return item.key == status; });
                if (!(statuses.length > 0)) 
                    allSubmitted = false;
            }
            if(allSubmitted && allCompleted)
                this.newBillingItemFormShow = true;
            else
                this.notify("Capture of clinical notes and/or invoice not complete. Complete them before adding another invoice.", "error")
            */
                this.newBillingItemFormShow = true;
        },
        closeNewBillingItemForm() {
            this.newBillingItemFormShow = false;
            this.newBillingItemFormKey = null;
        },
        getProviderName(poroviderId) {
            var prov = this.providers.filter(function (item) {
                return item.key == poroviderId;
            });
            if (prov.length > 0) return prov[0].value;
            else return "";
        },
        getProviderDisciplineName(disciplineId) {
            var discp = this.providerDisciplines.filter(function (item) {
                return item.key == disciplineId;
            });
            if (discp.length > 0) return discp[0].value;
            else return "";
        },
        setActiveProvider(providerId) {
            this.activeProviders = this.providers
                .filter(
                    (x) =>
                        x.disabled == false ||
                        (providerId > 0 && x.key == providerId)
                )
                .map((x) => {
                    const obj = {};
                    obj.value = x.value;
                    obj.key = x.key;
                    return obj;
                });
        },
        populateProviderDisciplines(providerId) {
            this.isLoading = true;
            this.$store
                .dispatch(
                    "providers/getMedediDisciplines",
                    this.billing.id > 0 ? undefined : providerId
                )
                .then((result) => {
                    if (providerId == this.billing.providerId && result) {
                        this.providerDisciplines = result;
                        if (
                            this.providerDisciplines.length > 0 &&
                            !(this.billing.discipline > 0)
                        )
                            this.billing.discipline =
                                this.providerDisciplines[0].key;
                    }
                })
                .finally(() => (this.isLoading = false));
        },
        async loadBilling() {
            this.closeNewBillingItemForm();
            this.populating = true;
            this.populatingFailure = true;
            this.billingIn = {};
            this.billing = {};

            if (this.billingIdValue > 0) {
                var requestId = (this.requestId = uuid4());
                var billingResponse = await this.$store.dispatch(
                    "billings/get",
                    {
                        id: this.billingIdValue,
                        urlParameters: {},
                        requestId: requestId,
                    }
                );
                if (
                    this.requestId == billingResponse.requestId &&
                    billingResponse.data.total == 1 &&
                    billingResponse.data.page[0].id == this.billingIdValue
                ) {
                    this.billingIn = billingResponse.data.page[0];
                    this.billing = new Billing().set(this.billingIn);
                    this.populatingFailure = false;


                }
            } else if (this.billingIdValue === 0) {
                this.billing = new Billing();
                this.populatingFailure = false;
            }
            this.populating = false;
                            this.setActiveProvider(this.billingIn.providerId);
                            if (
                                !(this.billingIn.providerId > 0) &&
                                this.providers &&
                                this.providers.length > 0
                            ) {
                                this.billing.providerId = this.providers[0].key;
                            }
                            this.populateProviderDisciplines(this.billing.providerId);
        },
        //emitters      ------------------------------------------------------------
        emitSavedEntity(savedBilling) {
            this.$emit("saved", savedBilling);
        },
        emitDeletedEntity(deletedBilling) {
            this.$emit("deleted", deletedBilling);
        },
        emitDeletedPatient(deletedPatient) {
            this.$emit("deletedPatient", deletedPatient);
        },
        emitCloseForm() {
            this.$emit("close");
        },
        //general       ------------------------------------------------------------
        notify(message, color) {
            this.notifyShow = true;
            this.notifyMessage = message;
            this.notifyColor = color;
        },
        closeForm() {
            this.notifyShow = false;
            this.emitCloseForm();
        },
        validateForm() {
            this.isValid = this.$refs.billingForm.validate();
            return this.isValid;
        },

        //save      ------------------------------------------------------------
        async saveEntity() {
            if (this.validateForm()) {
                this.isLoading = true;
                this.isSaving = true;
                var hasId = this.billing.id > 0;
                try {
                    var billingResponse = await this.$store.dispatch(
                        "billings/" + (hasId ? "update" : "create"),
                        this.billing
                    );
                    this.notify("Billing successfully saved.", "success");
                    if (!(this.billing.id > 0)) {
                        this.billing.id = billingResponse.id;
                        this.billingIdValue = this.billing.id;
                    }
                    this.emitSavedEntity(billingResponse);
                    await this.loadBilling();
                } catch (e) {
                    this.notify(e.response.data, "error");
                }
                this.saveEntityDone();
            }
        },
        saveEntityDone() {
            this.isLoading = false;
            this.isSaving = false;
            this.isSendingWelcome = false;
        },
        //delete        ------------------------------------------------------------
        deleteEntity() {
            var isConfirmed = confirm(
                "Are you sure you want to delete this billing?"
            );
            if (isConfirmed) {
                this.isLoading = true;
                this.isDeleting = true;
                this.$store
                    .dispatch("billings/delete", this.billing.id)
                    .then(
                        () => {
                            this.notify(
                                "Billing successfully deleted.",
                                "success"
                            );
                            this.emitDeletedEntity(this.billing);
                            this.closeForm();
                        },
                        (error) => this.notify(error.response.data, "error")
                    )
                    .finally(this.deleteEntityDone);
            }
        },
        deleteEntityDone() {
            this.isLoading = false;
            this.isDeleting = false;
        },

        //patient find forms-------------------
        loadPatientFindForm() {
            this.patientFindFormKey += 1;
            this.patientFindFormVisible = true;
        },
        closePatientFindForm() {
            this.patientFindFormVisible = false;
        },
        locatedPatient(patient) {
            this.billing.patientId = patient.id;
            this.billing.patient = patient;
        },
    },
};
</script>

<style lang="stylus" scoped></style>
